import { DefaultDocumentParser } from "../parser/default_documentparser";
import { Util } from "../utility/util";
export class MetaDocumentRenderer {

    constructor(p_jstemplatecenter, p_basicConfiguration) {
        this.jstemplatecenter = p_jstemplatecenter;
        this.basicConfiguration = p_basicConfiguration;
        this.sectionCount = 0;
        this.sectionFinishedCount = 0;
        this._afterAttachEventCallbacks; // Initialized by DocumentRenderer constructor
    }

     render(p_document, p_templateName, p_embedded) {

        let sections = [];
        this._handleSections(p_document, sections);
        p_document.sections = sections;

        p_document.tocVisible = (p_document.showTOC == 'true')? true : false;

        return this.jstemplatecenter.templates[p_templateName](p_document);
    }


    _handleSections(p_document, sections)
    {
        let references = p_document.references;

        if(!references) {
            return;
        }

        // Do not sort references. They are already sorted by KBase.

        let index = 1;
        let prefix = (p_document.chapter && p_document.chapter.length > 0)? p_document.chapter + '.' : '';
        for (let documentRef of references) {

            if (documentRef.isPartOfHTML == "true") {
                continue;
            }
            this.sectionCount++;

            documentRef.chapter = prefix + index;
            let chapters = documentRef.chapter.split('.');
            documentRef.chapterPath = chapters.join('_');

            let initialDepth = (p_document.depth != undefined)? (p_document.depth + 1) : 0;
            documentRef.depth = initialDepth + (chapters.length - 1);

            let l_docParser = new DefaultDocumentParser(this.basicConfiguration);
            if (!(this.basicConfiguration.embeddedInKFirst)) {
                if (this.basicConfiguration.customParsingFunction) {
                    this.basicConfiguration.customParsingFunction(documentRef.content, documentRef.componentType).then(p_parsedContent => {
                        documentRef.content = p_parsedContent;
                        const contentElement = Util.getElementByIdWithQuery(
							documentRef.chapterPath + "-body", this.basicConfiguration
						);
                        if(contentElement)
                        {
                            contentElement.innerHTML = p_parsedContent;
                        }
                        this._incrementSectionCount();
                    }).catch((e) => {
                        console.log(e);
                        this._incrementSectionCount();
                    });
                } else {
                    documentRef.content = l_docParser.parse(documentRef.content);
                    this._incrementSectionCount();
                    //l_docParser.addImageListeners(document.guid);
                    //l_docParser.registerImageForContainer(document.content);
                    //l_docParser.addReferenceListeners(this.basicConfiguration.renderDocumentFunction, this.baseErrorPattern.master);
                }
            } else {
                if (this.basicConfiguration.customParsingFunction) {
                    this.basicConfiguration.customParsingFunction(documentRef.content, documentRef.componentType).then(p_parsedContent => {
                        documentRef.content = p_parsedContent;
                        const contentElement = Util.getElementByIdWithQuery(
							documentRef.chapterPath + "-body",
							this.basicConfiguration
						);
                        if(contentElement)
                        {
                            contentElement.innerHTML = p_parsedContent;
                        }
                        this._incrementSectionCount();
                    }).catch(() => {
                        this._incrementSectionCount();
                    });
                } else {
                    this._incrementSectionCount();
                }
            }

            sections.push(documentRef);

            if(documentRef.componentType == 'meta') {
                this._handleSections(documentRef, sections);
            } else if (documentRef.componentType == 'documentReference') {
                this._incrementSectionCount();
            } else if(documentRef.componentType == 'activeDocument') {
                this._afterAttachEventCallbacks.push(function() {
                    let docOptions = {
                        isAD: true,
                        linkClickedListener: (customEvent) => console.log('LinkClickListener ', customEvent),
                        showDocumentHeader: false,
                        content: documentRef.chapterPath + '-body'
                      };
                    this.basicConfiguration.documentRenderer.renderDocument(documentRef.guid, null, documentRef.contentLang, docOptions);
                }.bind(this));
                this._incrementSectionCount();
            } else {
                let l_renderedContent = this.basicConfiguration.documentRenderer.renderWithDefaultTemplate(documentRef, true);
                if (this.basicConfiguration.customParsingFunction) {
                    documentRef.content = l_renderedContent;
                    this.basicConfiguration.customParsingFunction(l_renderedContent, documentRef.componentType).then(p_parsedContent => {
                        documentRef.content = p_parsedContent;

                        const contentElement = Util.getElementByIdWithQuery(
							documentRef.chapterPath + "-body", this.basicConfiguration
						);
                        if(contentElement)
                        {
                            contentElement.innerHTML = p_parsedContent;
                            this._incrementSectionCount();
                        }
                    },() => {
                        this._incrementSectionCount();
                    });
                } else {
                    this._incrementSectionCount();
                }
            }
            documentRef.componentType = documentRef.componentType;
            index++;
        }
    }

    _incrementSectionCount() {
        this.sectionFinishedCount++;

        if(this.sectionFinishedCount >= this.sectionCount) {
            this.basicConfiguration.documentRenderer.documentRendered = true;
        }
    }
}